import { useEffect, useState, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo_2.png";
import React from "react";

const injectStyles = () => {
  if (document.getElementById("ob5-styles")) return;
  const s = document.createElement("style");
  s.id = "ob5-styles";
  s.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    /* ── Bot keyframes ── */
    @keyframes slideInBot { from{opacity:0;transform:translateY(-8px) scale(0.96)} to{opacity:1;transform:translateY(0) scale(1)} }
    @keyframes botCursor  { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes speakBar   { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.9)} }
    @keyframes pulseDot   { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes botBobSvg  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-2.5px)} }
    @keyframes floatHeartL1 { 0%{transform:translate(0,0) scale(1);opacity:1} 100%{transform:translate(-14px,-54px) scale(0.18);opacity:0} }
    @keyframes floatHeartL2 { 0%{transform:translate(0,0) scale(0.82);opacity:0.9} 100%{transform:translate(-4px,-58px) scale(0.12);opacity:0} }
    @keyframes floatHeartL3 { 0%{transform:translate(0,0) scale(0.68);opacity:0.8} 100%{transform:translate(9px,-50px) scale(0.22);opacity:0} }
    @keyframes floatHeartR1 { 0%{transform:translate(0,0) scale(1);opacity:1} 100%{transform:translate(14px,-54px) scale(0.18);opacity:0} }
    @keyframes floatHeartR2 { 0%{transform:translate(0,0) scale(0.82);opacity:0.9} 100%{transform:translate(4px,-58px) scale(0.12);opacity:0} }
    @keyframes floatHeartR3 { 0%{transform:translate(0,0) scale(0.68);opacity:0.8} 100%{transform:translate(-9px,-50px) scale(0.22);opacity:0} }

    /* ── Confetti ── */
    @keyframes ob5-confetti {
      0%  { transform:translateY(-10px) rotate(0deg);   opacity:1; }
      100%{ transform:translateY(105vh) rotate(680deg); opacity:0; }
    }

    /* ── Page fade in ── */
    @keyframes ob5-fadeIn {
      from{ opacity:0; transform:translateY(20px); }
      to  { opacity:1; transform:translateY(0); }
    }

    /* ── Shimmer for overlay bar ── */
    @keyframes ob5-shimmer {
      0%  { background-position:200% center; }
      100%{ background-position:-200% center; }
    }

    /* ── Overlay animations ── */
    @keyframes ob5-overlaySlideUp {
      0%  { transform:translateY(100%); }
      100%{ transform:translateY(0); }
    }
    @keyframes ob5-overlaySlideDown {
      0%  { transform:translateY(0); }
      100%{ transform:translateY(100%); }
    }
    @keyframes ob5-iconBounce {
      0%  { transform:scale(0) translateY(20px); opacity:0; }
      50% { transform:scale(1.2) translateY(-6px); opacity:1; }
      70% { transform:scale(0.92) translateY(3px); opacity:1; }
      100%{ transform:scale(1) translateY(0); opacity:1; }
    }
    @keyframes ob5-textFade {
      0%  { opacity:0; transform:translateY(12px); }
      100%{ opacity:1; transform:translateY(0); }
    }
    @keyframes ob5-barGrow {
      0%  { width:0; opacity:0; }
      20% { opacity:1; }
      100%{ width:120px; opacity:1; }
    }
    @keyframes ob5-btnPulse {
      0%,100%{ box-shadow:0 4px 20px rgba(192,0,26,.4); }
      50%    { box-shadow:0 4px 32px rgba(192,0,26,.75), 0 0 0 6px rgba(192,0,26,.15); }
    }
    @keyframes ob5-ldot {
      0%,80%,100%{ transform:scale(0); opacity:0; }
      40%        { transform:scale(1); opacity:1; }
    }

    /* ── Bot SVG ── */
    .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
    .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }

    /* ── Bot popup ── */
    .ob5-wrap { position:fixed; z-index:99999; animation:slideInBot .28s cubic-bezier(.34,1.2,.64,1) both; }
    .ob5-wrap::before { content:''; position:absolute; width:16px; height:9px; background:#c0001a; clip-path:polygon(50% 0%,100% 100%,0% 100%); }
    .ob5-wrap.below::before   { top:-9px;    left:24px; }
    .ob5-wrap.above::before   { bottom:-9px; left:24px; transform:rotate(180deg); }
    .ob5-wrap.toright::before { top:24px;    left:-9px; transform:rotate(-90deg); }
    .ob5-wrap.toleft::before  { top:24px;    right:-9px; transform:rotate(90deg); }

    .ob5-card-popup { background:#fff; border-radius:14px; border:1px solid rgba(0,0,0,.07); overflow:hidden; box-shadow:0 4px 8px rgba(0,0,0,.06),0 18px 52px rgba(0,0,0,.18),0 2px 10px rgba(192,0,26,.1); }
    .ob5-hd { background:linear-gradient(135deg,#c0001a 0%,#8b0000 58%,#5c0000 100%); padding:12px 14px 10px; display:flex; align-items:center; gap:10px; position:relative; overflow:visible; }
    .ob5-hd::after { content:''; position:absolute; inset:0; pointer-events:none; background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px); background-size:16px 16px; }
    .ob5-av   { position:relative; flex-shrink:0; z-index:1; overflow:visible; }
    .ob5-bars { display:flex; align-items:flex-end; gap:2px; position:absolute; bottom:-3px; right:-4px; background:rgba(0,0,0,.3); border-radius:4px; padding:2px 3px; z-index:2; }
    .ob5-b    { width:2.5px; border-radius:2px; background:#fff; transform-origin:bottom; }
    .ob5-b:nth-child(1){ height:4px;  animation:speakBar .48s .00s ease-in-out infinite; }
    .ob5-b:nth-child(2){ height:9px;  animation:speakBar .48s .10s ease-in-out infinite; }
    .ob5-b:nth-child(3){ height:6px;  animation:speakBar .48s .20s ease-in-out infinite; }
    .ob5-b:nth-child(4){ height:3px;  animation:speakBar .48s .30s ease-in-out infinite; }
    .ob5-meta { flex:1; z-index:1; min-width:0; overflow:hidden; }
    .ob5-name { font-size:11.5px; font-weight:800; color:#fff; letter-spacing:.06em; font-family:'DM Mono','Fira Code',monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .ob5-sub  { font-size:9.5px; color:rgba(255,255,255,.7); display:flex; align-items:center; gap:4px; margin-top:2px; }
    .ob5-dot  { width:5px; height:5px; border-radius:50%; background:#6effa0; box-shadow:0 0 4px rgba(100,255,150,.85); flex-shrink:0; animation:pulseDot 2s ease-in-out infinite; }
    .ob5-badge{ z-index:1; flex-shrink:0; background:rgba(255,255,255,.16); border:1px solid rgba(255,255,255,.3); border-radius:20px; padding:2px 8px; font-size:10px; font-weight:700; color:#fff; white-space:nowrap; }
    .ob5-tag     { background:linear-gradient(90deg,#fff5f5,#fff); border-bottom:1px solid rgba(192,0,26,.1); padding:5px 14px; display:flex; align-items:center; gap:6px; }
    .ob5-tag-dot { width:5px; height:5px; border-radius:50%; background:#c0001a; flex-shrink:0; }
    .ob5-tag-txt { font-size:9.5px; font-weight:800; color:#c0001a; letter-spacing:.08em; }
    .ob5-body { padding:10px 14px 8px; }
    .ob5-msg  { font-size:13px; line-height:1.62; color:#1a1a1a; word-break:break-word; margin:0; }
    .ob5-msg strong { color:#c0001a; font-weight:800; }
    .ob5-cur  { display:inline-block; width:2px; height:13px; background:#c0001a; border-radius:2px; margin-left:2px; vertical-align:middle; animation:botCursor .65s ease-in-out infinite; }
    .ob5-ft   { padding:8px 14px 11px; display:flex; align-items:center; justify-content:space-between; gap:8px; border-top:1px solid rgba(0,0,0,.05); background:#fafafa; }
    .ob5-dots { display:flex; gap:4px; align-items:center; }
    .ob5-d    { width:6px; height:6px; border-radius:50%; background:#e0e0e0; transition:all .3s; }
    .ob5-d.on { width:18px; border-radius:999px; background:linear-gradient(90deg,#c0001a,#8b0000); }
    .ob5-skip { background:none; border:none; cursor:pointer; font-size:11px; color:#c0c0c0; padding:4px 6px; border-radius:6px; transition:all .18s; white-space:nowrap; }
    .ob5-skip:hover { background:#f0f0f0; color:#888; }
    .ob5-next { background:linear-gradient(135deg,#c0001a,#8b0000); color:#fff; border:none; border-radius:8px; padding:7px 16px; font-size:12px; font-weight:800; cursor:pointer; letter-spacing:.03em; box-shadow:0 3px 12px rgba(192,0,26,.32); transition:all .18s; white-space:nowrap; }
    .ob5-next:hover  { transform:translateY(-1px); box-shadow:0 5px 16px rgba(192,0,26,.46); }
    .ob5-next:active { transform:scale(.97); }

    /* ── Page ── */
    .ob5-section { background:#f8f5f0 !important; min-height:100vh !important; }

    /* ── Confetti ── */
    .ob5-confetti-wrap { position:fixed; inset:0; pointer-events:none; overflow:hidden; z-index:0; }
    .ob5-particle { position:absolute; top:-20px; animation:ob5-confetti linear forwards; opacity:0; }

    /* ── Main content ── */
    .ob5-main-wrap {
      display:flex; flex-direction:column; align-items:center; justify-content:center;
      min-height:calc(100vh - 80px); text-align:center; padding:40px 20px;
      animation:ob5-fadeIn .65s cubic-bezier(.34,1.1,.64,1) both;
      position:relative; z-index:1;
    }

    .ob5-big-heading {
      font-size:40px; font-weight:800; color:#1a1a1a;
      letter-spacing:-.03em; line-height:1.15;
      margin:0 0 20px; font-family:'Inter',sans-serif;
    }
    @media(max-width:600px){ .ob5-big-heading{ font-size:28px; } }

    .ob5-desc {
      font-size:16px; color:#4a5568; line-height:1.78;
      max-width:520px; margin:0 auto 44px;
      font-family:'Inter',sans-serif;
    }
    @media(max-width:600px){ .ob5-desc{ font-size:14px; } }

    /* ── Red pill CTA — pulsing to draw attention ── */
    .ob5-cta-btn {
      display:inline-flex; align-items:center; justify-content:center; gap:10px;
      background:#c0001a; color:#fff; border:none; border-radius:999px;
      padding:16px 52px; font-size:17px; font-weight:700;
      font-family:'Inter',sans-serif; letter-spacing:.01em;
      cursor:pointer; min-width:260px; height:56px;
      box-shadow:0 4px 20px rgba(192,0,26,.4);
      transition:background .18s, transform .18s;
      animation:ob5-btnPulse 2.4s ease-in-out infinite;
    }
    .ob5-cta-btn:hover:not(:disabled) {
      background:#a80017; transform:translateY(-3px);
      animation:none;
      box-shadow:0 8px 28px rgba(192,0,26,.55);
    }
    .ob5-cta-btn:active:not(:disabled) { transform:scale(.95); }
    .ob5-cta-btn:disabled {
      cursor:not-allowed; animation:none;
      box-shadow:0 4px 20px rgba(192,0,26,.3);
    }

    /* Loading dots */
    .ob5-ldots { display:inline-flex; align-items:center; gap:6px; }
    .ob5-ldots span { width:8px; height:8px; border-radius:50%; background:#fff; display:inline-block; }
    .ob5-ldots span:nth-child(1){ animation:ob5-ldot 1.2s 0.0s ease-in-out infinite; }
    .ob5-ldots span:nth-child(2){ animation:ob5-ldot 1.2s 0.2s ease-in-out infinite; }
    .ob5-ldots span:nth-child(3){ animation:ob5-ldot 1.2s 0.4s ease-in-out infinite; }

    /* ══ SLIDE-UP OVERLAY — comes from bottom, fills screen ══ */
    .ob5-overlay {
      position:fixed; inset:0; z-index:99998;
      background:linear-gradient(160deg, #c0001a 0%, #8b0000 50%, #4a0010 100%);
      display:flex; flex-direction:column; align-items:center; justify-content:center;
      overflow:hidden;

      /* Slide up from bottom */
      transform:translateY(100%);
      animation:ob5-overlaySlideUp 0.55s cubic-bezier(.32,.72,0,1) forwards;
    }
    .ob5-overlay.closing {
      animation:ob5-overlaySlideDown 0.55s cubic-bezier(.32,.72,0,1) forwards;
    }

    /* Subtle grid pattern on overlay */
    .ob5-overlay::before {
      content:''; position:absolute; inset:0; pointer-events:none;
      background-image:
        linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),
        linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px);
      background-size:32px 32px;
    }

    /* Big emoji/icon */
    .ob5-ov-icon {
      font-size:100px; line-height:1; margin-bottom:28px;
      animation:ob5-iconBounce .6s cubic-bezier(.34,1.4,.64,1) .35s both;
    }

    /* Title */
    .ob5-ov-title {
      font-size:30px; font-weight:800; color:#fff;
      font-family:'Inter',sans-serif; letter-spacing:-.025em;
      text-align:center; margin:0 20px;
      animation:ob5-textFade .45s ease .6s both;
    }

    /* Subtitle */
    .ob5-ov-sub {
      font-size:16px; color:rgba(255,255,255,.75);
      font-family:'Inter',sans-serif; margin-top:12px;
      text-align:center; max-width:300px; line-height:1.6;
      animation:ob5-textFade .45s ease .78s both;
    }

    /* Progress bar at bottom */
    .ob5-ov-bar-wrap {
      position:absolute; bottom:0; left:0; right:0; height:5px;
      background:rgba(255,255,255,.15);
    }
    /* Bar now grows over 3.5s to match the overlay visible duration */
    .ob5-ov-bar {
      height:100%; width:0;
      background:rgba(255,255,255,.85);
      animation:ob5-barGrow 3.5s cubic-bezier(.25,1,.5,1) .4s forwards;
    }
    @keyframes ob5-barGrow {
      0%  { width:0%;   opacity:0; }
      5%  { opacity:1; }
      100%{ width:100%; opacity:1; }
    }

    /* ── Mobile: compact, exact-anchor-aligned, overlap-safe bot popup ── */
    @media (max-width: 767px) {
      .ob5-wrap        { max-width:calc(100vw - 24px); }
      .ob5-card-popup  { border-radius:10px; }
      .ob5-hd          { padding:7px 8px 6px; gap:6px; }
      .ob5-av svg      { width:34px !important; height:34px !important; }
      .ob5-bars        { padding:1px 2px; bottom:-2px; right:-2px; }
      .ob5-b           { width:1.5px; }
      .ob5-name        { font-size:9px; letter-spacing:.03em; }
      .ob5-sub         { font-size:7.5px; }
      .ob5-dot         { width:4px; height:4px; }
      .ob5-badge       { font-size:8px; padding:1px 5px; }
      .ob5-tag         { padding:3px 8px; }
      .ob5-tag-dot     { width:4px; height:4px; }
      .ob5-tag-txt     { font-size:7.5px; }
      .ob5-body        { padding:6px 8px 5px; }
      .ob5-msg         { font-size:11px; line-height:1.4; }
      .ob5-ft          { padding:5px 8px 7px; }
      .ob5-skip        { font-size:9px; padding:2px 4px; }
      .ob5-next        { font-size:10px; padding:5px 10px; }
      .ob5-d           { width:4px; height:4px; }
      .ob5-d.on        { width:12px; }
    }
  `;
  document.head.appendChild(s);
};

/* ── BotFaceSVG ── */
const BotFaceSVG: React.FC = () => (
  <svg width="64" height="64" viewBox="0 0 72 72" fill="none" style={{ overflow:"visible" }}>
    <defs>
      <style>{`
        .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
        .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }
      `}</style>
    </defs>
    <g className="ob-bot-bob">
      <line x1="36" y1="10" x2="36" y2="3" stroke="rgba(255,255,255,0.82)" strokeWidth="2.5" strokeLinecap="round"/>
      <circle cx="36" cy="2" r="3.2" fill="rgba(255,255,255,0.9)"/>
      <rect x="7" y="10" width="58" height="46" rx="15" fill="rgba(255,255,255,0.97)"/>
      <circle cx="7"  cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2"/>
      <circle cx="65" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2"/>
      <rect x="11" y="17" width="24" height="20" rx="9" fill="#c0001a"/>
      <rect x="37" y="17" width="24" height="20" rx="9" fill="#8b0000"/>
      <ellipse cx="23" cy="27" rx="9" ry="8" fill="white"/>
      <ellipse cx="49" cy="27" rx="9" ry="8" fill="white"/>
      <g className="ob-hl1"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff3d6b"/></g>
      <g className="ob-hl2"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#c0001a" opacity="0.88"/></g>
      <g className="ob-hl3"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff7099"/></g>
      <g className="ob-hr1"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff3d6b"/></g>
      <g className="ob-hr2"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#c0001a" opacity="0.88"/></g>
      <g className="ob-hr3"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff7099"/></g>
      <path d="M16,46 Q36,60 56,46" stroke="#c0001a" strokeWidth="2.8" strokeLinecap="round" fill="none"/>
      <ellipse cx="12" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)"/>
      <ellipse cx="60" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)"/>
      <line x1="7"  y1="28" x2="2"  y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round"/>
      <line x1="7"  y1="36" x2="2"  y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round"/>
      <line x1="65" y1="28" x2="70" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round"/>
      <line x1="65" y1="36" x2="70" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round"/>
    </g>
  </svg>
);

/* ── Confetti ── */
const CONFETTI_COLORS = ["#38bdf8","#6366f1","#f472b6","#34d399","#fbbf24","#f87171","#a78bfa","#c0001a"];
const Confetti: React.FC = () => {
  const particles = Array.from({ length: 80 }, (_, i) => ({
    id:i, left:Math.random()*100,
    color:CONFETTI_COLORS[Math.floor(Math.random()*CONFETTI_COLORS.length)],
    size:6+Math.random()*8, delay:Math.random()*4,
    dur:4+Math.random()*4, circle:Math.random()>.5,
  }));
  return (
    <div className="ob5-confetti-wrap">
      {particles.map(p=>(
        <div key={p.id} className="ob5-particle" style={{
          left:`${p.left}%`, background:p.color,
          width:p.size, height:p.size,
          borderRadius:p.circle?"50%":"2px",
          animationDelay:`${p.delay}s`, animationDuration:`${p.dur}s`,
        }}/>
      ))}
    </div>
  );
};

/* ── Types & Bot data ── */
type BotSide = "below"|"above"|"toright"|"toleft";
interface StepData { tag:string; plain:string; html:React.ReactNode; sideLg:BotSide; }

// Shared sizing constants — used by BotPopup for its own box AND by Step5
// to size the spacer that pushes page content down so the popup never
// overlaps the next block. Kept small so the bot stays compact and hugs
// the exact anchor field on mobile.
const GAP = 8;
const POPUP_W_MOBILE = 230, POPUP_W_DESKTOP = 310;
const POPUP_H_MOBILE = 130, POPUP_H_DESKTOP = 240;

const TOTAL_BOT = 3;
// sideLg is always "below" now — the popup is forced to appear under its anchor
// on every screen size, so this field is kept only to satisfy the StepData type.
const BOT_STEPS: StepData[] = [
  {
    tag:"STEP 1 OF 3 — CONGRATS!",
    plain:"Congratulations! Your profile is all set and ready — matches are already waiting for you!",
    html:<>🎉 <strong>Congratulations!</strong> Your profile is all set — matches are already waiting!</>,
    sideLg:"below",
  },
  {
    tag:"STEP 2 OF 3 — ALMOST THERE!",
    plain:"Welcome aboard! Your profile is ready, and so are the matches waiting to meet you.",
    html:<>🌟 <strong>Welcome aboard!</strong> Your profile is ready — matches are waiting to meet you.</>,
    sideLg:"below",
  },
  {
    tag:"STEP 3 OF 3 — START NOW!",
    plain:"Tap Start Matching Now to meet real people and let the magic begin!",
    html:<>🚀 Tap <strong>Start Matching Now</strong> to meet real people and let the magic begin!</>,
    sideLg:"below",
  },
];

/* ── BotPopup ── */
interface PopupProps {
  anchorRef:React.RefObject<HTMLDivElement|null>;
  step:number; total:number; data:StepData;
  onSkip:()=>void; onNext:()=>void; nextLabel:string;
  onTypingDone?:()=>void;
}
const BotPopup: React.FC<PopupProps> = ({ anchorRef,step,total,data,onSkip,onNext,nextLabel,onTypingDone }) => {
  // Mobile gets a smaller card so it never overlaps content or screen edges.
  const isMobileScreen = typeof window !== "undefined" && window.innerWidth < 768;
  const PW = isMobileScreen ? POPUP_W_MOBILE : POPUP_W_DESKTOP;
  const POPUP_H = isMobileScreen ? POPUP_H_MOBILE : POPUP_H_DESKTOP;

  const [pos,setPos]=useState<{top:number;left:number;width:number}|null>(null);
  const [activeSide,setActiveSide]=useState<BotSide>("below");
  const [displayed,setDisplayed]=useState("");
  const [done,setDone]=useState(false);
  const [status,setStatus]=useState("typing...");
  const timerRef=useRef<ReturnType<typeof setTimeout>|null>(null);
  const retryRef=useRef<ReturnType<typeof setTimeout>|null>(null);

  const calcPos=useCallback(():boolean=>{
    if(!anchorRef.current)return false;
    const r=anchorRef.current.getBoundingClientRect();
    const vw=window.innerWidth,vh=window.innerHeight;
    if(r.width===0&&r.height===0)return false;

    // Popup always appears BELOW the anchor — never above, never to the side.
    // It hugs the anchor's own left edge (not screen-center) so it visually
    // sits directly under the block it refers to.
    if(vw<768){
      const popW = Math.min(vw - 16, PW);
      const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));
      let left = r.left;
      left = Math.max(8, Math.min(left, vw - popW - 8));
      setActiveSide("below");
      setPos({ top, left, width: popW });
      return true;
    }

    let left = r.left;
    if (left + PW > vw - 8) left = vw - PW - 8;
    left = Math.max(12, Math.min(left, vw - PW - 12));

    const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));

    setActiveSide("below");
    setPos({ top, left, width: PW });
    return true;
  },[anchorRef]);

  useEffect(()=>{
    let att=0;if(retryRef.current)clearTimeout(retryRef.current);setPos(null);
    const tryCalc=()=>{const ok=calcPos();if(!ok&&att++<50)retryRef.current=setTimeout(tryCalc,80);};
    tryCalc();
    window.addEventListener("resize",calcPos);window.addEventListener("scroll",calcPos,true);
    return()=>{if(retryRef.current)clearTimeout(retryRef.current);window.removeEventListener("resize",calcPos);window.removeEventListener("scroll",calcPos,true);};
  },[calcPos,step]);

  useEffect(()=>{
    setDisplayed("");setDone(false);setStatus("typing...");
    let i=0;
    const tick=()=>{
      if(i<=data.plain.length){setDisplayed(data.plain.slice(0,i++));timerRef.current=setTimeout(tick,21);}
      else{setDone(true);setStatus("Online — here to guide you!");if(onTypingDone)timerRef.current=setTimeout(onTypingDone,1800);}
    };
    tick();
    return()=>{if(timerRef.current)clearTimeout(timerRef.current);};
  },[data.plain,step]);

  if(!pos)return null;
  const isSide=activeSide==="toright"||activeSide==="toleft";
  return(
    <div className={`ob5-wrap ${activeSide}`} style={{top:pos.top,left:pos.left,width:pos.width,transform:isSide?"translateY(-50%)":"none"}}>
      <div className="ob5-card-popup" style={{width:"100%"}}>
        <div className="ob5-hd">
          <div className="ob5-av"><BotFaceSVG/><div className="ob5-bars"><div className="ob5-b"/><div className="ob5-b"/><div className="ob5-b"/><div className="ob5-b"/></div></div>
          <div className="ob5-meta"><div className="ob5-name">SLAMMMM GUIDE</div><div className="ob5-sub"><div className="ob5-dot"/><span>{status}</span></div></div>
          <div className="ob5-badge">{step}/{total}</div>
        </div>
        <div className="ob5-tag"><div className="ob5-tag-dot"/><div className="ob5-tag-txt">{data.tag}</div></div>
        <div className="ob5-body">{done?<p className="ob5-msg">{data.html}</p>:<p className="ob5-msg">{displayed}<span className="ob5-cur"/></p>}</div>
        <div className="ob5-ft">
          <div className="ob5-dots">{Array.from({length:total}).map((_,i)=><div key={i} className={`ob5-d${i+1===step?" on":""}`}/>)}</div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <button className="ob5-skip" onClick={onSkip}>Skip guide</button>
            <button className="ob5-next" onClick={onNext}
              onMouseEnter={e=>{(e.currentTarget as HTMLButtonElement).style.transform="translateY(-1px)";}}
              onMouseLeave={e=>{(e.currentTarget as HTMLButtonElement).style.transform="none";}}
            >{nextLabel}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════
   STEP 5 — MAIN
══════════════════════════════════════════════ */
const Step5 = () => {
  const navigate = useNavigate();

  const [showConfetti, setShowConfetti] = useState(false);
  const [botStep,      setBotStep]      = useState<number|null>(null);

  /* button state: idle | loading | done */
  const [btnState,     setBtnState]     = useState<"idle"|"loading"|"done">("idle");
  /* overlay: hidden | open | closing */
  const [overlay,      setOverlay]      = useState<"hidden"|"open"|"closing">("hidden");

  /* Track viewport width so the spacer (which pushes content down while the
     bot is showing) matches the popup's actual mobile/desktop size. */
  const [viewportW, setViewportW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const onResize = () => setViewportW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const spacerH = (viewportW < 768 ? POPUP_H_MOBILE : POPUP_H_DESKTOP) + GAP + 8;

  /* Renders an invisible spacer right after a bot-guide anchor. This pushes
     the next block down in normal document flow so the fixed-position bot
     popup (which floats below the anchor) never overlaps/hides it. */
  const BotSpacer = ({ n }: { n: number }) => (
    <div style={{ height: botStep === n ? spacerH : 0, transition: "height .2s ease" }} />
  );

  const refHeading = useRef<HTMLDivElement>(null);
  const refDesc    = useRef<HTMLDivElement>(null);
  const refCta     = useRef<HTMLDivElement>(null);

  const getBotRef = (n:number): React.RefObject<HTMLDivElement|null> => {
    if(n===1)return refHeading;
    if(n===2)return refDesc;
    return refCta;
  };

  useEffect(()=>{
    injectStyles();
    const t=setTimeout(()=>setShowConfetti(true),300);
    if(!localStorage.getItem("step5Guide")){
      localStorage.setItem("step5Guide","1");
      setTimeout(()=>setBotStep(1),800);
    }
    return()=>clearTimeout(t);
  },[]);

  useEffect(()=>{
    if(botStep===null)return;
    getBotRef(botStep)?.current?.scrollIntoView({behavior:"smooth",block:"center"});
  },[botStep]);

  const nextBot=useCallback(()=>setBotStep(p=>p!==null&&p<TOTAL_BOT?p+1:null),[]);
  const skipBot=useCallback(()=>setBotStep(null),[]);
  const handleTypingDone=useCallback(()=>setBotStep(prev=>(prev!==null&&prev<TOTAL_BOT)?prev+1:prev),[]);

  /* ══ Button click sequence ══
   *  Step 1 (0ms)       : button → "loading" dots
   *  Step 2 (1200ms)    : overlay slides up from bottom with 🎊 icon
   *  Step 3 (4700ms)    : overlay starts sliding back down  [1200 + 3500]
   *  Step 4 (5300ms)    : navigate to /dashboard            [4700 + 600]
   *
   *  Total user wait: ~5.3s — long enough to read the overlay comfortably
   */
  const handleStart = () => {
    if(btnState !== "idle") return;
    setBtnState("loading");

    // Step 2 — show overlay after 1200ms loading dots
    setTimeout(()=>{
      setBtnState("done");
      setOverlay("open");

      // Step 3 — start closing overlay after 3500ms (user has had time to read)
      setTimeout(()=>{
        setOverlay("closing");

        // Step 4 — navigate after close animation (600ms) finishes
        setTimeout(()=>{
          navigate("/dashboard");
        }, 600);

      }, 3500);
    }, 1200);
  };

  return (
    <>
      {/* Bot popup */}
      {botStep!==null && botStep>=1 && botStep<=TOTAL_BOT && (
        <BotPopup
          anchorRef={getBotRef(botStep)} step={botStep} total={TOTAL_BOT}
          data={BOT_STEPS[botStep-1]} onSkip={skipBot}
          onNext={botStep<TOTAL_BOT?nextBot:skipBot}
          nextLabel={botStep<TOTAL_BOT?"Next →":"Done ✓"}
          onTypingDone={botStep<TOTAL_BOT?handleTypingDone:undefined}
        />
      )}

      {/* Confetti */}
      {showConfetti && <Confetti/>}

      {/* ══ Slide-up overlay ══ */}
      {overlay !== "hidden" && (
        <div className={`ob5-overlay${overlay==="closing"?" closing":""}`}>
          <div className="ob5-ov-icon">🎊</div>
          <div className="ob5-ov-title">Let's find your match!</div>
          <div className="ob5-ov-sub">Taking you to your dashboard…</div>
          {/* Bottom progress bar — grows over 3.5s to signal remaining wait */}
          <div className="ob5-ov-bar-wrap">
            <div className="ob5-ov-bar"/>
          </div>
        </div>
      )}

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light bg-primary">
        <div className="container justify-content-center">
          <Link className="navbar-brand" to="/"><img src={logo} alt="Slammm" className="img-fluid"/></Link>
        </div>
      </nav>

      {/* Main */}
      <section className="ob5-section">
        <div className="ob5-main-wrap">

          {/* Heading */}
          <div ref={refHeading}>
            <h1 className="ob5-big-heading">You're All Set! 🎉</h1>
          </div>
          <BotSpacer n={1} />

          {/* Description */}
          <div ref={refDesc}>
            <p className="ob5-desc">
              Welcome aboard! Your profile is ready, and so are the matches waiting to meet you.<br/>
              Start exploring, connect, and let the magic begin. Dive in now and find your perfect vibe!
            </p>
          </div>
          <BotSpacer n={2} />

          {/* CTA button */}
          <div ref={refCta}>
            <button
              className="ob5-cta-btn"
              onClick={handleStart}
              disabled={btnState !== "idle"}
            >
              {btnState === "idle" && "Start Matching Now"}
              {btnState === "loading" && (
                <div className="ob5-ldots">
                  <span/><span/><span/>
                </div>
              )}
              {btnState === "done" && "✓ On your way!"}
            </button>
          </div>
          <BotSpacer n={3} />

        </div>
      </section>
    </>
  );
};

export default Step5;